"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppointmentResponse = void 0;
/**
 * A reply to an appointment request for a patient and/or practitioner(s), such as a confirmation or rejection.
 */
var AppointmentResponse = /** @class */ (function () {
    function AppointmentResponse() {
    }
    return AppointmentResponse;
}());
exports.AppointmentResponse = AppointmentResponse;
